import type { Agent } from '../types';
export const PRAAMIS_NAME = 'Praamis';
export function isPraamis(value: {official_name?:string; nickname?:string|null; role_key?:string} | undefined): boolean {
  return Boolean(value && (value.role_key ? /^(praamis|praamis_executive)$/i.test(value.role_key.trim()) : /^(praamis|promise)$/i.test(value.official_name?.trim()||'')));
}
export function employeeDisplayName(agent: Agent): string {
  return agent.nickname?.trim() || agent.official_name || (isPraamis(agent)?PRAAMIS_NAME:'Agent');
}
